import { render, staticRenderFns } from "./VisualizarEscalas.vue?vue&type=template&id=6a904561"
import script from "./VisualizarEscalas.vue?vue&type=script&lang=js"
export * from "./VisualizarEscalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports